import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Row, Col, Panel, ProgressBar, Alert } from 'react-bootstrap';

import { connect } from 'react-redux';
import {
  selectIntegration,
  selectDatatypes,
  addDatatype,
  removeDatatype,
  fetchIntegrations,
  fetchNetworkWithTerms,
  fetchDatatypes,
  removeNetwork,
  removeNetworkUpdateD3,
} from '../../actions/NetworkActions';
import { setGenes } from '../../actions/actions';

import Tutorial from '../Tutorial';
import Network from '../Network';
import NetworkSelectionToolbar from '../NetworkSelectionToolbar';

/*
 * The container component of the network selection toolbar.
 * Injected with current state.
 */

const NetworkSelection = connect(
  (state, props) => {
    const { group, idx } = props.id;
    const network = state.networkGroups[group][idx];
    return {
      // Currently selected integration for this network
      selectedIntegration: network?.selectedIntegration,

      // Currently selected data types for this network
      selectedDatatypes: network?.selectedDatatypes,

      // Currently queried genes for this network
      genes: network?.selectedGenes,
    };
  },
  (dispatch, props) => ({
    onIntegrationChange: (integration, genes, datatypes) => {
      dispatch(selectIntegration(integration, props.id));
      dispatch(fetchNetworkWithTerms(integration, genes, props.id, datatypes));
    },
    onGenesChange: (genes, integration, datatypes) => {
      dispatch(setGenes(genes, props.id));
      dispatch(fetchNetworkWithTerms(integration, genes, props.id, datatypes));
    },
    onDatatypeChange: (datatype, idx, added, integration, genes, types) => {
      let newTypes = [];
      if (added) {
        dispatch(addDatatype(datatype, props.id));
        newTypes = types;
        newTypes.push(datatype);
      } else {
        types.forEach((type, idx) => {
          if (type === datatype) dispatch(removeDatatype(props.id, idx));
          else newTypes.push(type);
        });
      }
      dispatch(fetchNetworkWithTerms(integration, genes, props.id, newTypes));
    },
    onRemoveNetwork: event => {
      dispatch(removeNetworkUpdateD3(props.id));
    },
    // Not yet implemented
    onDatatypeSelectAll: event => {},
    onDatatypeSubmit: event => {},
  }),
)(NetworkSelectionToolbar);

const NetworkApp = ({
  id,
  network,
  integrations,
  datatypes,
  integrationTitle,
  vertical,
  width,
  height,
  onInitNetwork,
  onNetworkFilter,
}) => {
  let networkjs = null;

  // Show progress bar if isFetching
  if (network.isFetching)
    networkjs = (
      <ProgressBar
        active
        striped
        label="Retrieving network"
        now={100}
        style={{ marginTop: '20px' }}
      />
    );
  else if (!network?.isFetching && (!network?.data || !network?.data?.genes)) {
    // An error occurred if we're no longer fetching and data are
    // still null or undefined
    networkjs = (
      <Alert bsStyle="warning" style={{ marginTop: '20px' }}>
        {network?.data && network?.data?.error}
      </Alert>
    );
  } else
    networkjs = (
      <Network
        id={id}
        vertical={vertical}
        onInitNetwork={onInitNetwork}
        onNetworkFilter={onNetworkFilter}
      />
    );

  return (
    <div className="NetworkApp">
      <NetworkSelection
        id={id}
        disabled={network.isFetching || !network.data}
        integrationTitle={integrationTitle}
        integrations={integrations}
        datatypes={datatypes}
      />
      {networkjs}
    </div>
  );
};

export default NetworkApp;
